import axios from "axios";
import config from "../config";

const https = require('https');

const agent = new https.Agent({
    rejectUnauthorized: false,
});

const instance = axios.create({
    baseURL: config.WS_BASE_URL,
});

instance.interceptors.request.use(async(config) => {
    config.httpsAgent = agent
    const token = localStorage.getItem("token");
    config.headers.Authorization = token ? token : "";
    config.headers.ContentType = "application/json";
    return config;
});
    
export const floorAll = async(floor) =>
    await instance.post("accomodation/floor/all",{floor});

export const roomCurrent = async(room) =>
    await instance.post("accomodation/room/current",{room});

export const checkIn = async(roomId,deposit,userId,about,managerId,bedding) =>
    await instance.post("accomodation/check/in",{roomId,deposit,userId,about,managerId,bedding});

export const checkOut = async(roomId,deduction,about,managerId,userId) =>
    await instance.post("accomodation/check/out",{roomId,deduction,about,managerId,userId});

export const roomClean = async(roomId) =>
    await instance.post("accomodation/room/clean",{roomId});

export const getRoomLogs = async(roomId) =>
    await instance.post("accomodation/room/logs",{roomId});

